module.exports = __webpack_public_path__ + "static/media/logo48x48.82f90bea.svg";